import React from 'react';
import { Link } from 'react-router-dom'
/*
<li className="nav-item">
		<Link to={'/usuario/direcciones'} className="nav-link" >Mis Direcciones</Link>
</li>*/
const UserMenu = (props) => (
	<section>
		<ul className="nav flex-column">
		  <li className="nav-item">
		    <Link to={'/usuario/perfil'} className="nav-link" >Mis Datos</Link>
		  </li>
		  <li className="nav-item">
		    <Link to={'/usuario/pedidos'} className="nav-link" >Mis Pedidos</Link>
		  </li>
		  <li className="nav-item">
		    <a href="" className="nav-link" onClick={props.salirAct}>Salir</a>
		  </li>
		</ul>

	</section>
);

export default UserMenu;



// WEBPACK FOOTER //
// ./src/components/user_menu.js